import {Feature} from "geojson";
import "./MapFeatureDetailsComponent.scss";
import {useMemo} from "react";
import {TranslationsService} from "../../services/Translations.service";

interface MapFeatureDetailsProps {
    feature: Feature | null;
    layerName: string;
    isActive: boolean;
    onClose: () => void;
}

const MapFeatureDetailsComponent: React.FC<MapFeatureDetailsProps> = ({feature, layerName, isActive, onClose}) => {
    const LAYER_FIELDS = useMemo(() => TranslationsService.getTranslations(layerName) || null, [layerName]);

    return (
        <div className={`feature-wrapper ${isActive ? "active" : ""}`}>
            <div className="feature_header">
                <div className="close">
                    <img onClick={onClose} src="/assets/icons/cross_white.png" alt="Close" />
                </div>
                <div className="feature_header_title">{layerName}</div>
            </div>
            <div className="feature_content">
                {LAYER_FIELDS ? (
                    <div>
                        {feature?.properties ? (
                            <div className="feature_fields">
                                {Object.entries(feature.properties ?? {}).map(([key, value]) => (
                                    LAYER_FIELDS[key] ? (
                                        <div className="feature_field" key={key}>
                                            <div className="feature_field_header">{LAYER_FIELDS[key] || key}:</div>
                                            <div className="feature_field_text">{String(value)}</div>
                                        </div>
                                    ) : ""
                                ))}
                            </div>
                        ) : (
                            <p>No feature selected</p>
                        )}
                    </div>
                ) : "Данні відсутні"}
            </div>
        </div>
    );
};

export default MapFeatureDetailsComponent;
